import { useEffect, useState } from "react";
import axios from "axios";

export const STATUS_TYPE = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  COMPLETED: "completed",
  DECLINED: "decline",
  AVAILABLE: "available",
};

export const useDemoSession = (influencerId, userId) => {
  const [loading, setLoading] = useState(false);
  const [demoStatus, setDemoStatus] = useState(null);
  const allowed = [STATUS_TYPE.DECLINED, STATUS_TYPE.AVAILABLE].includes(
    demoStatus,
  );
  const API = process.env.REACT_APP_API_URL;

  const requestDemoSession = async (slotId, purpose = "") => {
    console.log("demo session request init");
    console.log({ slotId, influencerId, userId, purpose });

    if (!slotId || !influencerId || !userId) {
      console.log("Missing required fields");
      return {
        success: false,
        message: "Missing required fields",
      };
    }

    console.log("requesting demo");

    try {
      setLoading(true);

      const { data } = await axios.post(`${API}/request-demo`, {
        clientId: userId,
        influencerId,
        slotId,
        purpose, // Add purpose to the request
      });

      if (data.success) {
        setDemoStatus(data.status || STATUS_TYPE.ACCEPTED);
        console.log("Requested successfully");
        return {
          success: true,
          status: data.status,
          requestId: data.requestId,
          message: "Demo session requested successfully",
        };
      } else {
        return {
          success: false,
          message: data.message || "Failed to request demo session",
        };
      }
    } catch (error) {
      console.error("Failed to request demo", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Failed to request demo session. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  const getDemoStatus = async () => {
    if (!influencerId || !userId) return;

    try {
      setLoading(true);

      const { data } = await axios.post(`${API}/get-by-client-influencer`, {
        influencerId,
        clientId: userId,
      });
      console.log("Demo status response:", data);

      if (data.exists && data.record?.status) {
        setDemoStatus(data.record.status);
      } else {
        setDemoStatus(STATUS_TYPE.AVAILABLE);
      }
    } catch (error) {
      console.error("Failed to get demo status", error);
      setDemoStatus(STATUS_TYPE.AVAILABLE);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDemoStatus();
  }, [influencerId, userId]);

  console.log({ allowed, demoStatus, loading });

  return {
    influencerId,
    userId,
    loading,
    demoStatus,
    requestDemoSession,
    refreshStatus: getDemoStatus,
    allowed,
  };
};
